<h1 mat-dialog-title>{{data.isEdit ? '' : 'Új'}} Tulajdonság</h1>
<div mat-dialog-content>
    <mat-form-field class="w-100">
        <mat-label>Name</mat-label>
        <input matInput type="text" placeholder="Name" name="name" [(ngModel)]="item.name" required>
    </mat-form-field>
    <app-select-search label="Type" [list]="types" [model]="item.type" (modelChanged)="item.type = $event;" [isRequired]="true"></app-select-search>
</div>
<div mat-dialog-actions align="end">
    <!--<button *ngIf="data.item && data.item.id" mat-button (click)="onConfirmDelete()" color="warn" >Delete</button>-->
    <button mat-button (click)="onNoClick()">Bezár</button>
    <button mat-button color="primary" (click)="onSaveClick()" translate>SAVE</button>
</div>
